var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmarkUnselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.25V2.25C0 1.7 0.196 1.229 0.588 0.837C0.979333 0.445667 1.45 0.25 2 0.25H12C12.55 0.25 13.021 0.445667 13.413 0.837C13.8043 1.229 14 1.7 14 2.25V18.25L7 15.25L0 18.25ZM2 15.2L7 13.05L12 15.2V2.25H2V15.2Z",
    fill: "#ADB5BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkUnselected);
export default __webpack_public_path__ + "static/media/bookmark_unselected.8b36915a2af315e8eaf5abd0b36d3003.svg";
export { ForwardRef as ReactComponent };